import { orderBy } from "@/utils/object";
import type { AppointmentModel } from "./AppointmentModel";
import { BookModelCollection } from "../BookModel/BookModelCollection";

export class AppointmentModelCollection extends BookModelCollection<AppointmentModel> {
  futureAppointments() {
    const now = new Date();
    return this.filter((appointment) => appointment.get<Date>("from")! >= now);
  }
  findNextAppointment(placement: string) {
    const nextAppointment = orderBy(
      this.futureAppointments().all(),
      ["from.date"],
      ["asc"],
    )?.[0];
    if (!nextAppointment) return null;

    const timespan = nextAppointment.getTimespans().first();
    return {
      at: nextAppointment.getFromToAuto(placement),
      title: timespan.getAsTitle([], {
        placement,
        hidePrice: true,
        hideDateTime: true,
        hidePlacesLeft: true,
      }),
    };
  }
}
